import React from "react";
import axios from "axios";
import moment from "moment";

/**
 * Set a cookie
 * @param {string} key - The name of the cookie.
 * @param {string} value - The value of the cookie.
 * @param {Object} options - Additional options like `expires`, `path`, `secure`.
 */
export const setCookie = (key, value, options = {}) => {
  let cookieString = `${encodeURIComponent(key)}=${encodeURIComponent(
    typeof value === "string" ? value : JSON.stringify(value)
  )};`;

  if (options.expires) {
    const expiresDate =
      typeof options.expires === "number"
        ? new Date(Date.now() + options.expires * 864e5).toUTCString()
        : options.expires.toUTCString();
    cookieString += `expires=${expiresDate};`;
  }

  if (options.path) {
    cookieString += `path=${options.path};`;
  }

  if (options.secure) {
    cookieString += "secure;";
  }

  if (options.sameSite) {
    cookieString += `samesite=${options.sameSite};`;
  }

  document.cookie = cookieString;
};

/**
 * Get a cookie by name
 * @param {string} key - The name of the cookie to retrieve.
 * @returns {string | undefined} - The cookie value or undefined if not found.
 */
export const getCookie = (key) => {
  const cookies = document.cookie
    .split("; ")
    .map((cookie) => cookie.split("="))
    .reduce(
      (acc, [k, v]) => ({
        ...acc,
        [decodeURIComponent(k)]: decodeURIComponent(v),
      }),
      {}
    );

  return cookies[key];
};

/**
 * Delete a cookie by name
 * @param {string} key - The name of the cookie to delete.
 * @param {Object} options - Optional configurations (e.g., path).
 */
export const deleteCookie = (key, options = {}) => {
  setCookie(key, "", { ...options, expires: new Date(0) });
};

// Rendering Utility Functions
export function renderRequired() {
  return <span className="danger">*</span>;
}

export function renderOptional() {
  return <span style={{ color: "#5B6670" }}>(Optional)</span>;
}

export function fetchPublicIP(callback) {
  fetch("https://api.ipify.org?format=json")
    .then((response) => response.json())
    .then((data) => callback(null, data.ip))
    .catch((error) => callback(error, null));
}

export async function fetchLocationDetails(ip) {
  try {
    const locationResponse = await axios.get(`http://ip-api.com/json/${ip}`);
    if (locationResponse.data.status === "success") {
      const newLocation = {
        country: locationResponse.data.country,
        region: locationResponse.data.regionName,
        city: locationResponse.data.city,
        zip: locationResponse.data.zip,
        latitude: locationResponse.data.lat,
        longitude: locationResponse.data.lon,
      };
      return newLocation;
    } else {
      console.error("Failed to fetch location details");
      return null;
    }
  } catch (error) {
    console.error("Error fetching location details:", error);
    return null;
  }
}

export function getDeviceType() {
  let deviceType = "";
  const ua = navigator.userAgent;
  if (/mobile/i.test(ua)) {
    deviceType = "Mobile";
  } else if (/tablet|ipad|playbook|silk/i.test(ua)) {
    deviceType = "Tablet";
  } else {
    deviceType = "Desktop";
  }
  return deviceType;
}


export function dateFormat(date, addtime = false) {
  if (!date || date === "Invalid Date" || date === "Invalid date" || date === "0000-00-00" || date === "0000-00-00 00:00:00") {
    return "";
  }
  const m = moment(date);
  if (!m.isValid()) {
    return "";
  }
  const formatted = m.format(addtime ? "ddd, DD MMM YYYY, h:mm A" : "ddd, DD MMM YYYY");
  return formatted === "Invalid date" || formatted === "Invalid Date" ? "" : formatted;
}


export const isValidAustralianPhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/\s+/g, "");
  return /^(\+?61\d{9})$/.test(cleaned); // matches +614XXXXXXXX or 614XXXXXXXX
};